export default __webpack_public_path__ + "static/media/mdubore.8c9ebf9d.png";